import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import * as DateHelpers from './DateHelpers';

interface AllocatePlaceHolderProps {
    scheduleDate: string;
    onOffhireDate: string;
    showModal: boolean;
    hideModal(): void;
    update(scheduleDate: string, onOffhireDate: string): void;
    saveModal(): void;
}

interface AllocatePlaceHolderModal {
    errors: any;
}


export default class AllocatePlaceHolderData extends React.Component<AllocatePlaceHolderProps, AllocatePlaceHolderModal> {
    constructor(props: AllocatePlaceHolderProps) {
        super(props);

        this.state = {
            errors: {},
        }
    }

    hideModal = () => {
        this.setState({ errors: {} });
        this.props.hideModal();
    }

    handleDateChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
            this.setState({ errors: errors });
        }

        this.props.update(e.target.value, this.props.onOffhireDate);
    }

    handleOnOffHireChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
            this.setState({ errors: errors });
        }

        this.props.update(this.props.scheduleDate, e.target.value);
    }

    validate = () => {
        let errors: any = {};
        let formIsValid = true;

        if (!this.props.scheduleDate) {
            errors["scheduleDate"] = "Schedule Date is required";
            formIsValid = false;
        } else if (!DateHelpers.isValidDate(this.props.scheduleDate)) {
            errors["scheduleDate"] = "Schedule Date is required";
            formIsValid = false;
        }

        if (!this.props.onOffhireDate) {
            errors["onOffhireDate"] = "On/Off Hire Date is required";
            formIsValid = false;
        } else if (!DateHelpers.isValidDate(this.props.onOffhireDate)) {
            errors["onOffhireDate"] = "On/Off Hire Date is required";
            formIsValid = false;
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    schedule = (e: any) => {
        e.preventDefault();

        if (this.validate()) {
            this.props.saveModal();
        }
    }

    render() {
        return (
            <div className="static-modal">
                <Modal className="sizemd" show={this.props.showModal} onHide={this.hideModal}>
                    <Modal.Header className="modal__header--colour">
                        <Modal.Title>Create Placeholder Job</Modal.Title>
                        <button type="button" className="close" onClick={this.hideModal}>&times;</button>
                    </Modal.Header>
                    <Modal.Body>
                        <label className="input-group" htmlFor="scheduleDate">
                            <span className="label">Schedule Date </span>
                            <input className="input" type="date" id="scheduleDate" name="scheduleDate" value={this.props.scheduleDate} onChange={(e) => this.handleDateChange(e)}></input>
                        </label>
                        <span className="label errors">{this.state.errors["scheduleDate"]}</span>

                        <label className="input-group" htmlFor="onOffhireDate">
                            <span className="label">On/Off Hire Date </span>
                            <input className="input" type="date" id="onOffhireDate" name="onOffhireDate" value={this.props.onOffhireDate} onChange={(e) => this.handleOnOffHireChange(e)}></input>
                        </label>
                        <span className="label errors">{this.state.errors["onOffhireDate"]}</span>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="popup-button--yes" onClick={this.schedule}>Schedule</button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}